import React from 'react'
import {Helmet} from 'react-helmet'
import locationsData from './locationsData'

// Location selector. Serves as BOTH the root homepage ("/") and "/order" of
// the multi-location app — the real marketing homepage will be built later.
// Links are plain <a>, not react-router <Link>: each location is its own
// router under a different basename, so switching requires a full navigation.

const LOGO_URL = "https://res.cloudinary.com/dgps1radv/image/upload/h_300/vfbfxkg6xwojalgk7trr"

export default function Order () {
  return (
    <div id="pick-locations" role="main" aria-labelledby="location-header">
      <Helmet>
        <title>Los Amigos Mexican Restaurant | Order Online | Choose Location</title>
        <meta name="description" content="Order online for pickup or delivery from Los Amigos Mexican Restaurant — Burbank and Santa Clarita locations." />
      </Helmet>

      <div className="order-header">
        <img className="brand-logo" src={LOGO_URL} alt="Los Amigos Mexican Restaurant" />
        <h1 id="location-header" className="header-text">
          Choose a location to order online for pickup or delivery
        </h1>
      </div>

      <div className="ordering-locations-list" id="ordering-locations-list">
        {locationsData.map(({id, label, address, phone, phoneLink, hours, orderLink, disabled, openingDate}) => {
          const content = (
            <>
              <h2 className="title">{label}</h2>

              <div className="address">
                {address[0]} <br/>
                {address[1]}
              </div>

              <div className="phone">
                <a
                  className="phone-link"
                  href={`tel:${phoneLink}`}
                  onClick={(e) => e.stopPropagation()}
                >{phone}</a>
              </div>

              <ul className="hours-of-operation">
                {hours.map(({day, hours: hoursText}) => (
                  <li key={day}>{day}: {hoursText}</li>
                ))}
              </ul>

              {disabled ?
                <div className="coming-soon">{openingDate || "coming soon"}</div> :
                <div className="order-cta">order pickup or delivery →</div>}
            </>
          )

          if (disabled) {
            return (
              <div key={id} className="location disabled" aria-label={`${label} location — ${openingDate || "coming soon"}`}>
                {content}
              </div>
            )
          }

          return (
            <a
              key={id}
              href={orderLink}
              className="location"
              aria-label={`Order from the ${label} location at ${address[0]}, ${address[1]}`}
            >
              {content}
            </a>
          )
        })}
      </div>
    </div>
  )
}
